import React, { useEffect, useState } from 'react'
import { Row, Col } from "react-bootstrap"
import '../../styles/css/Card.css';
import HomeStadistic from '../../components/Products/sKPI/HomeStadistic/index.js';
import { useDispatch, useSelector } from "react-redux";
import HomeKpiListBox from '../../components/Products/sKPI/HomeKpiListBox/index';
import { useOrderDataKpi } from '../../hooks/component/useOfTransversal.js';
import { getGlobalListPageSize } from '../../common/Helpers.js';
import MessageLastEventsBox from '../../components/Products/sKPI/GAP/MessageLastEventsBox/indexHome';
import MessageLastActionsBox from '../../components/Products/sKPI/GAP/MessageLastActionsBox/indexHome';
import { useGetHomeBoardKpiGraph, useGetHomeBoardStadistic } from '../../hooks/services/sKPI/useOfBoard';
import { useGetHomeGapStadistic } from '../../hooks/services/sKPI/useOfGAP';
import MainAppContext from '../../MainAppContext';
import { useContext } from 'react';
import StackedChart from '../../components/Products/sKPI/HomeChart/StackedChart';
import PieChart from '../../components/Products/sKPI/HomeChart/PieChart';
import { action_clearBoardContext, action_clearDataserieContext } from '../../reducers/actions/KPI/actions';
import AuthVerify from '../../components/Templates/Site/AuthVerify';

function HomeV2() {
    const dispatch = useDispatch();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);
    const userName = currentAuth !== null ? currentAuth.token.userName.split('\\')[1] : null;

    const [objHomeStadisticData, setObjHomeStadisticData] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: getGlobalListPageSize("homeKpiList"), filters: []});

    const [objHomeBoardStadisticData, setObjHomeBoardStadisticData] = useState(null);
    useGetHomeBoardStadistic(contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId, contextSite.kpiModule.boardCalendarFilterConfig.value.periodId, objHomeBoardStadisticData, setObjHomeBoardStadisticData);

    const [objHomeGAPStadisticData, setObjHomeGAPStadisticData] = useState(null);
    useGetHomeGapStadistic(contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId, contextSite.kpiModule.boardCalendarFilterConfig.value.periodId, objHomeGAPStadisticData, setObjHomeGAPStadisticData);
    
    const [objHomeKpiGraph, setObjHomeKpiGraph] = useState(null);
    useGetHomeBoardKpiGraph(objHomeKpiGraph, setObjHomeKpiGraph);

    const [selectedStadisticCard, setSelectedStadisticCard] = useState(null);
    const [fireOrderData, setFireOrderData] = useState(false);
    const [boardReduxClear, setBoardReduxClear] = useState(false);
    useOrderDataKpi(objHomeStadisticData.data, objHomeBoardStadisticData, objHomeGAPStadisticData, setObjHomeStadisticData, selectedStadisticCard, fireOrderData, setFireOrderData);

    const { _boardStructure: objBoard } = useSelector((state) => state.boardScope);

    useEffect(() => {
        if (!boardReduxClear) {
            dispatch(action_clearBoardContext())
            dispatch(action_clearDataserieContext())
            setBoardReduxClear(true)
        }
    }, [objBoard]);

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row>
                <Col xl={12}>
                    <HomeStadistic
                        objStadisticData={objHomeStadisticData}
                        selectedStadisticCard={selectedStadisticCard}
                        setSelectedStadisticCard={setSelectedStadisticCard}
                        setFireOrderData={setFireOrderData}
                        setObjHomeStadisticData={setObjHomeStadisticData} />
                </Col>
            </Row>
            <Row className='pt-2'>
                <Col lg={12} xl={3} className='pe-1'>
                    {
                        objHomeKpiGraph &&
                        <StackedChart inputParam_DataserieChartItem={objHomeKpiGraph} />
                    }
                    {
                        objHomeBoardStadisticData &&
                        <PieChart inputParam_DataserieChartItem={objHomeBoardStadisticData} />
                    }
                </Col>
                <Col lg={12} xl={6} className='px-1'>
                    {
                        boardReduxClear &&
                        <HomeKpiListBox
                            bookList={objHomeStadisticData}
                            setBookList={setObjHomeStadisticData}
                            securityProps={ contextSite.securityProps }
                            userName={ userName }
                        />
                    }
                    
                </Col>
                <Col lg={12} xl={3} className='ps-1'>
                    <Row className='h-50'>
                        <Col className='h-100'>
                            <MessageLastEventsBox
                                inputParam_CalledFromHome={true}
                            />
                        </Col>
                    </Row>
                    <Row className='h-50'>
                        <Col className='h-100'>
                            <MessageLastActionsBox
                                inputParam_CalledFromHome={true}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
}

export default HomeV2;